/**
 * @generated SignedSource<<60fe638981449357cab066d42976d438>>
 * @relayHash fdaf9504150fa708867e08e9752ed8bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1264fb515de718e2607f9242bbc4d72c52ae8fe0180e0a71d62b4f5355009107

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

import isJiraCustomTemplatesUxEnabled_provider from '@atlassian/jira-relay-provider/src/jira-custom-templates-ux-fg.relayprovider';
import showTeamButton_provider from '@atlassian/jira-relay-provider/src/jira-team-button.relayprovider';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1264fb515de718e2607f9242bbc4d72c52ae8fe0180e0a71d62b4f5355009107",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": showTeamButton_provider
    }
  }
};

export default node;
